import Subject from "../cse4sub/Subject";
import React from 'react'

export default function se() {
  return (
    <div>
       <Subject title="Software Engineering(CSE604)"sub="Soft Engg." syllabus="#"
    book1="RajibMall, Fundamentals of Software Engineering. 3ed, PHI."
     book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=33307068&h=79fa26fcc31eeb88c657df98f89bf60a&u=cache&ext=pdf
    " book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}